export default __webpack_public_path__ + "static/media/qr-code.797e270d.svg";